import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import type { Middleware } from 'redux';
//import logger from 'redux-logger';
import counterReducer from '../features/counter/counterSlice';
import filterReducer from '../features/filter/filterSlice';
import noteReducer from '../features/note/noteSlice';
import pageReducer from '../features/page/pageSlice';
import ticketReducer from '../features/ticket/ticketSlice';
import fileReducer from '../features/file/fileSlice';
import userReducer from '../features/auth/user/userSlice';
import sessionReducer from '../features/auth/session/sessionSlice';
import tagReducer from '../features/tag/tagSlice';
import timeTableReducer from '../features/time-table/timeTableSlice';
import mapReducer from '../features/map/mapSlice';
import settingsReducer from '../features/settings/settingsSlice';

import { apiSlice } from '../api/index';

/*
const logger = store => next => action => {
  console.log('dispatching', action)
  let result = next(action)
  console.log('next state', store.getState())
  return result
}

const crashReporter = store => next => action => {
  try {
    return next(action)
  } catch (err) {
    console.error('Caught an exception!', err)
    Raven.captureException(err, {
      extra: {
        action,
        state: store.getState()
      }
    })
    throw err
  }
}
// */
function logger() {
  const loggerMiddleware: Middleware =
    ({ getState }) =>
    next =>
    action => {
      //console.log('will dispatch', action)

      // Call the next dispatch method in the middleware chain.
      const returnValue = next(action)

      //console.log('state after dispatch', getState())

      // This will likely be the action itself, unless
      // a middleware further in chain changed it.
      return returnValue
    }

  return loggerMiddleware
}

export const store = configureStore({
	reducer: {
		counter: counterReducer,
		filter: filterReducer,
		note: noteReducer,
		page: pageReducer,
		timeTable: timeTableReducer,
		ticket: ticketReducer,
		file: fileReducer,
		tag: tagReducer,
		user: userReducer,
		session: sessionReducer,
		map: mapReducer,
		settings: settingsReducer,
		[apiSlice.reducerPath]: apiSlice.reducer
	},
	middleware: getDefaultMiddleware =>
	getDefaultMiddleware().concat(apiSlice.middleware).concat(logger())
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
